/*
 * @Author: your name
 * @Date: 2021-11-11 19:30:13
 * @LastEditTime: 2023-11-06 10:37:24
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /weapp-passportweb/src/components/pc/signup/verify/store.ts
 */
import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog } from '@weapp/ui';

import * as SignAPI from '../../../../api/pc/signup';
import { getAreaCodeStorage, getAccountStorage } from '../../../../utils';
import { checkMobileType, checkSkipType } from './type';
import { qryDumpAccountVaild } from "../../../../api/pc/signup";
const { message } = Dialog;

export class SignVerifyStore {
  @observable loading: boolean = false;//加载中
  @observable captchaBase64: any = '';//图形验证码
  @observable graphcodeCheck: any = {};//验证码状态
  @observable isShowSkipVerifyBtn = "E"


  init = () => {
    const phoneFeild = getAreaCodeStorage();
    const account = getAccountStorage();
    const isForeign = !!(account.indexOf('@') === -1 && phoneFeild && phoneFeild !== '+86');
    if (isForeign) {
      // this.getForeignGraphCode();
    }
  }

  @action
  changeGraphcodeCheck = (checkConfig: any) => {
    this.graphcodeCheck = checkConfig;
  }
  /**
   * 国外手机号额外图形验证码
   */
  @action
  getForeignGraphCode = () => {
    SignAPI.getForeignGraphCode().then((result) => {
      if (result.data?.errorMsg) {
        const msg = result.data.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        runInAction(() => {
          this.captchaBase64 = result;
        });
      }
    });
  }

  /**
   * 判断是否显示跳过验证
   */

  @action
  qryDumpAccountVaild = async () => {
    const res = await qryDumpAccountVaild()
    console.log("res", res);
    runInAction(() => {
      this.isShowSkipVerifyBtn = res?.data?.configValue || "E"
    })

  }


  /**
   * 跳过验证
   * @param callback 
   */
  @action
  skipVerify = (params: checkSkipType, callback?: () => void) => {
    this.loading = true;
    SignAPI.skipValidate(params).then((result) => {
      runInAction(() => {
        this.loading = false;
      });
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        });
      } else {
        //从邀请来
        if (params.joinKey && result.data?.redirectUrl) {
          window.location.href = result.data?.redirectUrl;
          return;
        }
        callback && callback();
      }
    });
  }
  /**
   * 发送验证码
   * @param callback 
   */
  @action
  sendVerify = (params: any, callback?: () => void) => {

    SignAPI.sendMobileCode(params).then((result) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        callback && callback();
      }
    });
  }
  /**
   * 校验验证码
   * @param callback 
   */
  @action
  checkVerify = (params: checkMobileType, callback?: () => void) => {
    this.loading = true;
    SignAPI.checkMobileCode(params).then((result: any) => {
      runInAction(() => {
        this.loading = false;
      });
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        //从邀请来
        if (params.joinKey && result.data?.redirectUrl) {
          window.location.href = result.data?.redirectUrl;
          return;
        }
        callback && callback();
      }
    });
  }
  /**
   * 重新发送邮件
   * @param callback 
   */
  @action
  sendEmail = (callback?: Function) => {
    SignAPI.sendEmail().then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result?.data?.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        })
      } else {
        callback?.();
      }
    });
  }


}
const instance = new SignVerifyStore();

export default instance;
export type SignVerifyStoreType = Pick<SignVerifyStore, keyof SignVerifyStore>;
